// extracted by mini-css-extract-plugin
export var backdropBlur = "_mq-0";
export var contentCard = "_mq-5";
export var frame = "_mq-2";
export var image = "_mq-4";
export var imagePane = "_mq-3";
export var modal = "_mq-1";